import React from "react";
import 'src/App.scss'
import './BrandLegalInfo.scss'
import {toPublicUrl} from "src/modules/util/UrlUtil";
import {BrowserServiceSingleton} from "src/Context";
import {BrandContext} from "src/modules/brand/BrandContext";
import {BrandConfig} from "src/modules/brand/BrandConfig";

/**
 * The SIMPL home block at the foot of the tile.
 *
 * The house mark and the "Powered by Network Funding, LP." line are platform identity and are
 * deliberately fixed — the lender is named in LenderRow above, not here. What does follow the
 * brand is the license line: NMLS and the Terms / Licensing / Privacy destinations, which differ
 * per lender even though the platform statement does not.
 */
export class BrandLegalInfo extends React.Component {

    /** Platform statement. Not brand-configurable by design. */
    private static readonly PLATFORM_LINE = "Powered by Network Funding, LP.";

    static contextType = BrandContext;
    context!: BrandConfig;

    private goToAdminLogin = () => {
        BrowserServiceSingleton.redirectTo('/admin-login');
    };

    render() {
        return (
            <div id="brand-legal-info" className="content-inner-wrapper">

                <div id="logo-container" onClick={this.goToAdminLogin} className="logo-container--clickable">

                    <img src={toPublicUrl("/images/nflp-logo-stamp-white.png")} alt="NFLP"/>

                </div>

                <div id="legal-container">

                    <h5>{BrandLegalInfo.PLATFORM_LINE}</h5>

                    <h6>{this.getNMLS()} | {this.getTerms()} | {this.getLicensing()} | {this.getPrivacy()} | {this.getCopyright()}</h6>

                </div>

            </div>
        );
    }

    private getNMLS = () => <>NMLS #{this.context.nmls} | Equal Housing Lender</>;
    private getTerms = () => <a href={this.context.termsUrl} target="_new">Terms</a>;
    private getLicensing = () => <a href={this.context.licensingUrl} target="_new">Licensing</a>;
    private getPrivacy = () => <a href={this.context.privacyUrl} target="_new">Privacy</a>;
    private getCopyright = () => <> © {new Date().getFullYear()}</>;
}
